export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7957.a8b0bc17.jpg";